import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table, Row, Form, Input, Col } from 'antd';
import PageTitle from '../../../Components/PageTitle';
class ClinicalAdmin extends Component {
  render() {
    var adminUserInfo = JSON.parse(localStorage.getItem('adminUserInfo'));
    var displayNotes = false;
    var displayNotesText = '';
    var displayMasterBillServices = false;
    var displayMasterBillServicesText = '';
    var displayGoalsLibrary = false;
    var displayGoalsLibraryText = '';
    var displayTermsConditions = false;
    var displayTermsConditionsText = '';
    var displayMergePatients = false;
    var displayMergePatientsText = '';
    var displayStaff = false;
    var displayStaffText = '';
    for (var item of adminUserInfo) {
      if (item.key == 'notes') {
        displayNotes = true;
        displayNotesText = item.text;
      } else if (item.key == 'master-bill-services') {
        displayMasterBillServices = true;
        displayMasterBillServicesText = item.text;
      } else if (item.key == 'goals-library') {
        displayGoalsLibrary = true;
        displayGoalsLibraryText = item.text;
      } else if (item.key == 'termsConditionsLibrary') {
        displayTermsConditions = true;
        displayTermsConditionsText = item.text;
      } else if (item.key == 'merge-patients') {
        displayMergePatients = true;
        displayMergePatientsText = item.text;
      } else if (item.key == 'clinical-staff') {
        displayStaff = true;
        displayStaffText = item.text;
      }
    }
    const links = [
      <ul class="admin-page-link2">
        {displayNotes && (
          <li>
            <Link to="/cw/manage/un-sign-notes">
              <figure class="admin-link-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="65" viewBox="0 0 52 65">
                  <defs>
                    <linearGradient id="managementgradient" x1="0%" y1="50%" y2="50%">
                      <stop offset="0%" stop-color="#00F2FE" />
                      <stop offset="2.08%" stop-color="#03EFFE" />
                      <stop offset="29.31%" stop-color="#24D2FE" />
                      <stop offset="55.38%" stop-color="#3CBDFE" />
                      <stop offset="79.56%" stop-color="#4AB0FE" />
                      <stop offset="100%" stop-color="#4FACFE" />
                    </linearGradient>
                  </defs>
                  <path
                    fill="url(#managementgradient)"
                    fill-rule="nonzero"
                    d="M41.38 65H10.162C4.563 65 .007 60.444.007 54.844V10.156C.007 4.556 4.563 0 10.163 0H41.38c5.6 0 10.156 4.556 10.156 10.156v31.992a2.539 2.539 0 1 1-5.078 0V10.156c0-2.8-2.278-5.078-5.078-5.078H10.163a5.084 5.084 0 0 0-5.078 5.078v44.688c0 2.8 2.278 5.078 5.078 5.078H41.38c2.8 0 5.078-2.278 5.078-5.078a2.539 2.539 0 1 1 5.078 0c0 5.6-4.556 10.156-10.157 10.156zm.014-46.084a2.539 2.539 0 0 0-2.54-2.539h-24.49a2.539 2.539 0 1 0 0 5.078h24.49a2.539 2.539 0 0 0 2.54-2.539zm0 14.615a2.539 2.539 0 0 0-2.54-2.539h-24.49a2.539 2.539 0 1 0 0 5.078h24.49a2.539 2.539 0 0 0 2.54-2.539zm0 14.362a2.539 2.539 0 0 0-2.54-2.54h-24.49a2.539 2.539 0 1 0 0 5.079h24.49a2.539 2.539 0 0 0 2.54-2.54z"
                  />
                </svg>
              </figure>
              <span class="d-block h4 font-weight-normal">{displayNotesText}</span>
            </Link>
          </li>
        )}
        {displayMasterBillServices && (
          <li>
            <Link to="/cw/manage/master-bill-services?tab=overhead-cost">
              <figure class="admin-link-icon">
                <svg
                  width="75"
                  height="71"
                  viewBox="0 0 75 71"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M37.2292 0.113669C37.5599 -0.0378896 37.9401 -0.0378896 38.2708 0.113669L50.2708 5.61367C50.7151 5.81731 51 6.26124 51 6.75V19.4304L61.7484 24.1037C62.2048 24.3021 62.5 24.7523 62.5 25.25V34.4344L74.2534 39.6059C74.7071 39.8055 75 40.2543 75 40.75V56.25C75 56.7314 74.7236 57.17 74.2893 57.3777L62.7893 62.8777C62.4547 63.0377 62.0663 63.0409 61.7292 62.8863L56.3033 60.3995L38.3558 70.3434C37.9744 70.5547 37.5104 70.552 37.1315 70.3362L19.7117 60.4167L14.809 62.868C14.4764 63.0343 14.087 63.0439 13.7466 62.8941L1.24658 57.3941C0.792881 57.1945 0.5 56.7457 0.5 56.25V40.25C0.5 39.7543 0.792881 39.3055 1.24658 39.1059L13 33.9344V25.75C13 25.2686 13.2764 24.83 13.7107 24.6223L24.5 19.4622V6.75C24.5 6.26124 24.7849 5.81731 25.2292 5.61367L37.2292 0.113669ZM24.5 22.2334L15.5 26.5378V33.9775L25.809 39.132C26.2325 39.3437 26.5 39.7765 26.5 40.25V56.25C26.5 56.7235 26.2325 57.1563 25.809 57.368L22.4018 59.0716L37.7584 67.8163L53.4802 59.1056L49.7292 57.3863C49.2849 57.1827 49 56.7388 49 56.25V40.25C49 39.7598 49.2865 39.3149 49.7327 39.112L60 34.4451V26.0696L51 22.1565V22.25C51 22.7388 50.7151 23.1827 50.2708 23.3863L38.2708 28.8863C37.9401 29.0379 37.5599 29.0379 37.2292 28.8863L25.2292 23.3863C24.7849 23.1827 24.5 22.7388 24.5 22.25V22.2334ZM48.5 21.4479V8.69796L39 13.0521V25.802L48.5 21.4479ZM36.5 25.802V13.0521L27 8.69796V21.4479L36.5 25.802ZM28.7501 6.75L37.75 10.875L46.7499 6.75L37.75 2.62504L28.7501 6.75ZM61.2583 36.6193L53.1525 40.3037L62.2622 44.8586L70.7538 40.7973L61.2583 36.6193ZM72.5 42.7334L63.5 47.0378V59.7666L72.5 55.4622V42.7334ZM61 59.802V47.0225L51.5 42.2725V55.4479L61 59.802ZM14.2161 36.1306L4.74151 40.2994L14.2136 44.846L22.5513 40.2982L14.2161 36.1306ZM24 42.3557L15.5 46.992V59.7275L24 55.4775V42.3557ZM13 59.8344V47.0365L3 42.2365V55.4344L13 59.8344Z"
                    fill="url(#paint0_linear_22961_35062)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_22961_35062"
                      x1="0.500092"
                      y1="70.5"
                      x2="75.0001"
                      y2="70.5"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.021" stop-color="#03EFFE" />
                      <stop offset="0.293" stop-color="#24D2FE" />
                      <stop offset="0.554" stop-color="#3CBDFE" />
                      <stop offset="0.796" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                  </defs>
                </svg>
              </figure>
              <span class="d-block h4 font-weight-normal">{displayMasterBillServicesText}</span>
            </Link>
          </li>
        )}
        {displayGoalsLibrary && (
          <li>
            <Link to="/cw/manage/goals-library">
              <figure class="admin-link-icon">
                <svg
                  width="77"
                  height="77"
                  viewBox="0 0 77 77"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M68.265 0.500778C67.7574 0.486018 67.2661 0.681914 66.9082 1.04211L58.5363 9.4139L58.5325 9.41772C58.0424 9.9185 57.8789 10.6545 58.1127 11.3159L59.4058 14.9919L35.1933 39.1844C34.2281 38.6438 33.1202 38.3259 31.9349 38.3259C28.2269 38.3259 25.1834 41.357 25.1834 45.067C25.1834 48.7763 28.2266 51.8159 31.9349 51.8159C35.6448 51.8159 38.6762 48.7752 38.6762 45.067C38.6762 43.869 38.3499 42.7484 37.7985 41.7764L62.0091 17.5948L65.6856 18.8904C66.3469 19.124 67.0831 18.9606 67.5839 18.4704L67.5878 18.4666L75.9604 10.0917C76.4084 9.64457 76.5942 8.99779 76.454 8.38138C76.3131 7.7652 75.8657 7.26413 75.2681 7.05551L75.2671 7.05516L71.3382 5.66484L69.9475 1.73681L69.9468 1.73471C69.7541 1.18097 69.3143 0.76279 68.7746 0.589278L68.7788 0.515718L68.265 0.500778ZM68.1628 7.72113L68.172 7.71956L68.1635 7.72257C68.3487 8.2414 68.7564 8.65014 69.276 8.83564L69.278 8.83637L71.3035 9.54959L65.9592 14.8958L65.8103 15.0448L62.9649 14.0362L61.9538 11.191L66.5262 6.6191L67.4496 5.69582L68.1628 7.72113ZM28.8602 45.0662C28.8602 43.3566 30.2215 42.0002 31.9341 42.0002C33.6447 42.0002 34.9973 43.3546 34.9973 45.0662C34.9973 46.7792 33.6428 48.14 31.9341 48.14C30.223 48.14 28.8602 46.7773 28.8602 45.0662Z"
                    fill="url(#paint0_linear_22961_35091)"
                  />
                  <path
                    d="M31.9341 13.6407C14.5921 13.6407 0.5 27.7242 0.5 45.0665C0.5 62.4087 14.5918 76.5 31.9341 76.5C49.2766 76.5 63.3575 62.4083 63.3575 45.0665C63.3575 39.398 61.8242 33.8334 58.9206 28.9658C58.6865 28.5228 58.2807 28.1939 57.7985 28.0567C57.3106 27.9181 56.7872 27.987 56.3516 28.2478C55.9167 28.508 55.6083 28.9377 55.5 29.433C55.394 29.9222 55.4911 30.4342 55.771 30.8503C58.3345 35.1488 59.6824 40.0618 59.6824 45.0672C59.6824 60.4109 47.2779 72.8256 31.9342 72.8256C16.5904 72.8256 4.17527 60.4113 4.17527 45.0672C4.17527 29.724 16.5896 17.3165 31.9342 17.3165C36.9438 17.3165 41.8587 18.6666 46.1599 21.2344C46.2026 21.2624 46.2463 21.2885 46.2909 21.3126L46.9177 21.6869V21.5176C47.131 21.5467 47.35 21.5383 47.5645 21.4904C48.0571 21.3811 48.4828 21.074 48.742 20.6418C49.0009 20.2093 49.0716 19.6894 48.9362 19.2034C48.802 18.7222 48.4772 18.3159 48.0377 18.0794C43.2304 15.2111 37.7436 13.6805 32.1498 13.6423L32.1483 13.6407H31.9341Z"
                    fill="url(#paint1_linear_22961_35091)"
                  />
                  <path
                    d="M31.9341 25.736C21.2725 25.736 12.604 34.405 12.604 45.0658C12.604 55.7266 21.2732 64.394 31.9341 64.394C42.595 64.394 51.2627 55.7275 51.2627 45.0658C51.2627 42.7474 50.8431 40.4509 50.0293 38.2806C50.0076 38.2101 49.9817 38.1414 49.952 38.0747L49.9046 37.9485H49.8898C49.712 37.6197 49.4361 37.3499 49.0961 37.1798C48.6388 36.9507 48.1062 36.9231 47.6274 37.1026C47.1488 37.2824 46.7667 37.6546 46.5726 38.1272C46.3815 38.5942 46.391 39.1188 46.5984 39.5785C47.2549 41.3327 47.5869 43.1913 47.5869 45.0657C47.5869 53.729 40.5969 60.728 31.9335 60.728C23.2705 60.728 16.2709 53.7278 16.2709 45.0657C16.2709 36.4032 23.2709 29.4111 31.9335 29.4111C33.8131 29.4111 35.6763 29.7457 37.4348 30.4057L37.5198 30.4376H37.5292C38.4538 30.7244 39.4513 30.2422 39.7944 29.3251C40.1487 28.3778 39.6714 27.3224 38.7267 26.9624L38.7244 26.9615C36.5515 26.1459 34.2533 25.736 31.9341 25.736Z"
                    fill="url(#paint2_linear_22961_35091)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_22961_35091"
                      x1="0.499886"
                      y1="76.4999"
                      x2="76.4996"
                      y2="76.4999"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_22961_35091"
                      x1="0.499886"
                      y1="76.4999"
                      x2="76.4996"
                      y2="76.4999"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_22961_35091"
                      x1="0.499886"
                      y1="76.4999"
                      x2="76.4996"
                      y2="76.4999"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                  </defs>
                </svg>
              </figure>
              <span class="d-block h4 font-weight-normal">{displayGoalsLibraryText}</span>
            </Link>
          </li>
        )}
        {displayTermsConditions && (
          <li>
            <Link to="/cw/manage/terms-conditions-list">
              <figure class="admin-link-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="65" viewBox="0 0 52 65">
                  <defs>
                    <linearGradient id="managementgradient" x1="0%" y1="50%" y2="50%">
                      <stop offset="0%" stop-color="#00F2FE" />
                      <stop offset="2.08%" stop-color="#03EFFE" />
                      <stop offset="29.31%" stop-color="#24D2FE" />
                      <stop offset="55.38%" stop-color="#3CBDFE" />
                      <stop offset="79.56%" stop-color="#4AB0FE" />
                      <stop offset="100%" stop-color="#4FACFE" />
                    </linearGradient>
                  </defs>
                  <path
                    fill="url(#managementgradient)"
                    fill-rule="nonzero"
                    d="M41.38 65H10.162C4.563 65 .007 60.444.007 54.844V10.156C.007 4.556 4.563 0 10.163 0H41.38c5.6 0 10.156 4.556 10.156 10.156v31.992a2.539 2.539 0 1 1-5.078 0V10.156c0-2.8-2.278-5.078-5.078-5.078H10.163a5.084 5.084 0 0 0-5.078 5.078v44.688c0 2.8 2.278 5.078 5.078 5.078H41.38c2.8 0 5.078-2.278 5.078-5.078a2.539 2.539 0 1 1 5.078 0c0 5.6-4.556 10.156-10.157 10.156zm.014-46.084a2.539 2.539 0 0 0-2.54-2.539h-24.49a2.539 2.539 0 1 0 0 5.078h24.49a2.539 2.539 0 0 0 2.54-2.539zm0 14.615a2.539 2.539 0 0 0-2.54-2.539h-24.49a2.539 2.539 0 1 0 0 5.078h24.49a2.539 2.539 0 0 0 2.54-2.539zm0 14.362a2.539 2.539 0 0 0-2.54-2.54h-24.49a2.539 2.539 0 1 0 0 5.079h24.49a2.539 2.539 0 0 0 2.54-2.54z"
                  />
                </svg>
              </figure>

              <span class="d-block h4 font-weight-normal">{displayTermsConditionsText}</span>
            </Link>
          </li>
        )}
        {displayMergePatients && (
          <li>
            <Link to="/cw/manage/merge-patients">
              <figure class="admin-link-icon">
                <svg
                  width="109"
                  height="50"
                  viewBox="0 0 109 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M88.7184 3.26376C94.0668 3.26376 98.4172 7.61417 98.4172 12.9626C98.4172 17.009 95.8247 19.5002 94.2795 20.6249C93.3259 21.3189 92.8205 22.474 92.9586 23.6455C93.0966 24.817 93.8553 25.8226 94.9445 26.2773C101.011 28.8052 104.931 34.6779 104.931 41.2409V44.2476C104.931 45.6192 103.815 46.735 102.443 46.735H74.9933C73.6217 46.735 72.506 45.6192 72.506 44.2476V41.2409C72.506 34.6792 76.4258 28.8052 82.4923 26.2773C83.5815 25.8239 84.3401 24.817 84.4781 23.6455C84.6162 22.474 84.1109 21.3189 83.1572 20.6249C81.6121 19.5002 79.0195 17.009 79.0195 12.9626C79.0195 7.61417 83.3712 3.26376 88.7184 3.26376ZM88.7184 0C81.5589 0 75.7558 5.80435 75.7558 12.9626C75.7558 17.2737 77.9987 20.9073 81.2372 23.2643C74.1967 26.1975 69.2422 33.1366 69.2422 41.2409V44.2476C69.2422 47.4239 71.817 50 74.9933 50H102.443C105.62 50 108.195 47.4252 108.195 44.2476V41.2409C108.195 33.1366 103.24 26.1987 96.1996 23.2643C99.438 20.9073 101.681 17.2737 101.681 12.9626C101.681 5.80435 95.8779 0 88.7184 0Z"
                    fill="white"
                  />
                  <path
                    d="M19.4762 3.26376C24.8246 3.26376 29.175 7.61417 29.175 12.9626C29.175 17.009 26.5825 19.5002 25.0374 20.6249C24.0837 21.3189 23.5784 22.474 23.7164 23.6455C23.8545 24.817 24.6131 25.8226 25.7023 26.2773C31.7688 28.8052 35.6886 34.6779 35.6886 41.2409V44.2476C35.6886 45.6192 34.5728 46.735 33.2012 46.735H5.74989C4.37828 46.735 3.2625 45.6192 3.2625 44.2476V41.2409C3.2625 34.6792 7.1823 28.8052 13.2488 26.2773C14.338 25.8239 15.0966 24.817 15.2347 23.6455C15.3727 22.474 14.8674 21.3189 13.9137 20.6249C12.3686 19.5002 9.77608 17.009 9.77608 12.9626C9.77735 7.61417 14.1278 3.26376 19.4762 3.26376ZM19.4762 0C12.3167 0 6.51359 5.80435 6.51359 12.9626C6.51359 17.2737 8.75656 20.9073 11.995 23.2643C4.95453 26.1975 0 33.1366 0 41.2409V44.2476C0 47.4239 2.57479 50 5.75116 50H33.2012C36.3776 50 38.9524 47.4252 38.9524 44.2476V41.2409C38.9524 33.1366 33.9978 26.1987 26.9574 23.2643C30.1958 20.9073 32.4388 17.2737 32.4388 12.9626C32.4388 5.80435 26.6344 0 19.4762 0Z"
                    fill="white"
                  />
                  <path
                    d="M61.6741 29.1992H46.5192C45.6175 29.1992 44.8867 28.4697 44.8867 27.5667C44.8867 26.6649 45.6175 25.9342 46.5192 25.9342H61.6729C62.5746 25.9342 63.3054 26.6637 63.3054 27.5667C63.3054 28.4684 62.5759 29.1992 61.6741 29.1992Z"
                    fill="white"
                  />
                  <path
                    d="M55.7286 19.9887V35.1436C55.7286 36.0453 54.9991 36.7761 54.0961 36.7761C53.1943 36.7761 52.4635 36.0453 52.4635 35.1436V19.9899C52.4635 19.0882 53.1931 18.3574 54.0961 18.3574C54.9978 18.3574 55.7286 19.0869 55.7286 19.9887Z"
                    fill="white"
                  />
                  <path
                    d="M88.7184 3.26376C94.0668 3.26376 98.4172 7.61417 98.4172 12.9626C98.4172 17.009 95.8247 19.5002 94.2795 20.6249C93.3259 21.3189 92.8205 22.474 92.9586 23.6455C93.0966 24.817 93.8553 25.8226 94.9445 26.2773C101.011 28.8052 104.931 34.6779 104.931 41.2409V44.2476C104.931 45.6192 103.815 46.735 102.443 46.735H74.9933C73.6217 46.735 72.506 45.6192 72.506 44.2476V41.2409C72.506 34.6792 76.4258 28.8052 82.4923 26.2773C83.5815 25.8239 84.3401 24.817 84.4781 23.6455C84.6162 22.474 84.1109 21.3189 83.1572 20.6249C81.6121 19.5002 79.0195 17.009 79.0195 12.9626C79.0195 7.61417 83.3712 3.26376 88.7184 3.26376ZM88.7184 0C81.5589 0 75.7558 5.80435 75.7558 12.9626C75.7558 17.2737 77.9987 20.9073 81.2372 23.2643C74.1967 26.1975 69.2422 33.1366 69.2422 41.2409V44.2476C69.2422 47.4239 71.817 50 74.9933 50H102.443C105.62 50 108.195 47.4252 108.195 44.2476V41.2409C108.195 33.1366 103.24 26.1987 96.1996 23.2643C99.438 20.9073 101.681 17.2737 101.681 12.9626C101.681 5.80435 95.8779 0 88.7184 0Z"
                    fill="url(#paint0_linear_4847_1979)"
                  />
                  <path
                    d="M19.4762 3.26376C24.8246 3.26376 29.175 7.61417 29.175 12.9626C29.175 17.009 26.5825 19.5002 25.0374 20.6249C24.0837 21.3189 23.5784 22.474 23.7164 23.6455C23.8545 24.817 24.6131 25.8226 25.7023 26.2773C31.7688 28.8052 35.6886 34.6779 35.6886 41.2409V44.2476C35.6886 45.6192 34.5728 46.735 33.2012 46.735H5.74989C4.37828 46.735 3.2625 45.6192 3.2625 44.2476V41.2409C3.2625 34.6792 7.1823 28.8052 13.2488 26.2773C14.338 25.8239 15.0966 24.817 15.2347 23.6455C15.3727 22.474 14.8674 21.3189 13.9137 20.6249C12.3686 19.5002 9.77608 17.009 9.77608 12.9626C9.77735 7.61417 14.1278 3.26376 19.4762 3.26376ZM19.4762 0C12.3167 0 6.51359 5.80435 6.51359 12.9626C6.51359 17.2737 8.75656 20.9073 11.995 23.2643C4.95453 26.1975 0 33.1366 0 41.2409V44.2476C0 47.4239 2.57479 50 5.75116 50H33.2012C36.3776 50 38.9524 47.4252 38.9524 44.2476V41.2409C38.9524 33.1366 33.9978 26.1987 26.9574 23.2643C30.1958 20.9073 32.4388 17.2737 32.4388 12.9626C32.4388 5.80435 26.6344 0 19.4762 0Z"
                    fill="url(#paint1_linear_4847_1979)"
                  />
                  <path
                    d="M61.6741 29.1992H46.5192C45.6175 29.1992 44.8867 28.4697 44.8867 27.5667C44.8867 26.6649 45.6175 25.9342 46.5192 25.9342H61.6729C62.5746 25.9342 63.3054 26.6637 63.3054 27.5667C63.3054 28.4684 62.5759 29.1992 61.6741 29.1992Z"
                    fill="url(#paint2_linear_4847_1979)"
                  />
                  <path
                    d="M55.7286 19.9887V35.1436C55.7286 36.0453 54.9991 36.7761 54.0961 36.7761C53.1943 36.7761 52.4635 36.0453 52.4635 35.1436V19.9899C52.4635 19.0882 53.1931 18.3574 54.0961 18.3574C54.9978 18.3574 55.7286 19.0869 55.7286 19.9887Z"
                    fill="url(#paint3_linear_4847_1979)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_4847_1979"
                      x1="69.2423"
                      y1="25"
                      x2="121.705"
                      y2="25"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_4847_1979"
                      x1="0.000108771"
                      y1="25"
                      x2="52.4625"
                      y2="25"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_4847_1979"
                      x1="44.8868"
                      y1="27.5667"
                      x2="69.6936"
                      y2="27.5667"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_4847_1979"
                      x1="44.8868"
                      y1="27.5667"
                      x2="69.6936"
                      y2="27.5667"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#00F2FE" />
                      <stop offset="0.0208" stop-color="#03EFFE" />
                      <stop offset="0.2931" stop-color="#24D2FE" />
                      <stop offset="0.5538" stop-color="#3CBDFE" />
                      <stop offset="0.7956" stop-color="#4AB0FE" />
                      <stop offset="1" stop-color="#4FACFE" />
                    </linearGradient>
                  </defs>
                </svg>
              </figure>
              <span class="d-block h4 font-weight-normal">{displayMergePatientsText}</span>
            </Link>
          </li>
        )}
        {displayStaff && (
          <li>
            <Link to="/cw/manage/clinical-staff/external">
              <figure class="admin-link-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">
                  <defs>
                    <linearGradient id="staffgradient" x1="0%" y1="50%" y2="50%">
                      <stop offset="0%" stop-color="#00F2FE" />
                      <stop offset="2.08%" stop-color="#03EFFE" />
                      <stop offset="29.31%" stop-color="#24D2FE" />
                      <stop offset="55.38%" stop-color="#3CBDFE" />
                      <stop offset="79.56%" stop-color="#4AB0FE" />
                      <stop offset="100%" stop-color="#4FACFE" />
                    </linearGradient>
                  </defs>
                  <path
                    fill="url(#staffgradient)"
                    fill-rule="nonzero"
                    d="M23.05 10.479a2.534 2.534 0 0 1-.015-3.583l4.914-4.96A6.275 6.275 0 0 1 32.437.064c1.696 0 3.29.666 4.487 1.874l4.914 4.959a2.534 2.534 0 1 1-3.6 3.567l-3.267-3.298V23.63a2.534 2.534 0 1 1-5.069 0V7.165l-3.268 3.298a2.534 2.534 0 0 1-3.584.016zm20.146 12.67a2.535 2.535 0 0 0 3.584-.015l3.269-3.298v11.65a2.534 2.534 0 1 0 5.067 0v-11.65l3.269 3.298c.495.5 1.148.75 1.8.75a2.534 2.534 0 0 0 1.8-4.318l-4.915-4.959a6.275 6.275 0 0 0-4.488-1.873c-1.696 0-3.29.665-4.487 1.873l-4.915 4.959a2.535 2.535 0 0 0 .016 3.583zm-36.581.111l3.268-3.297v11.523a2.534 2.534 0 0 0 5.068 0V19.963l3.269 3.297c.495.5 1.148.75 1.8.75a2.534 2.534 0 0 0 1.8-4.318l-4.915-4.958a6.275 6.275 0 0 0-4.488-1.873c-1.696 0-3.29.665-4.487 1.873l-4.915 4.958a2.535 2.535 0 0 0 3.6 3.568zm57.437 40.126a4.184 4.184 0 0 1-3.258 1.55h-16.17c-.027 0-.053-.004-.08-.004-.048.001-.095.003-.143.003H20.646l-.093-.002-.05.002H4.331a4.184 4.184 0 0 1-3.258-1.549 4.207 4.207 0 0 1-.858-3.524c.72-3.463 2.873-6.35 5.755-8.09a7.938 7.938 0 0 1-1.536-4.701c0-4.402 3.581-7.983 7.982-7.983 4.402 0 7.983 3.581 7.983 7.983a7.936 7.936 0 0 1-1.53 4.69l.12.072a17.119 17.119 0 0 1 6.268-5.028 9.46 9.46 0 0 1-2.198-6.07c0-5.24 4.263-9.502 9.503-9.502s9.503 4.263 9.503 9.502a9.46 9.46 0 0 1-2.198 6.07 17.119 17.119 0 0 1 6.268 5.027l.12-.07a7.938 7.938 0 0 1-1.529-4.691c0-4.402 3.58-7.982 7.982-7.982 4.401 0 7.982 3.58 7.982 7.982 0 4.356-3.509 7.907-7.848 7.978-.023.001-.045.004-.068.004h-.132c-1.441 0-2.832.423-4.018 1.205.295.775.536 1.572.716 2.385.02.066.036.132.05.2.071.34.104.684.103 1.025h10.452a2.535 2.535 0 0 1 4.964-.006 4.206 4.206 0 0 1-.858 3.524zM49.795 47.071a2.917 2.917 0 0 0 2.914 2.914 2.917 2.917 0 0 0 2.914-2.914 2.917 2.917 0 0 0-2.914-2.915 2.917 2.917 0 0 0-2.914 2.915zM32.563 45.17a4.44 4.44 0 0 0 4.435-4.435 4.44 4.44 0 0 0-4.435-4.434 4.44 4.44 0 0 0-4.434 4.434 4.44 4.44 0 0 0 4.434 4.435zM20.705 59.868h23.687a.117.117 0 0 0 .025-.022c-1.186-5.57-6.161-9.608-11.854-9.608-5.7 0-10.68 4.047-11.858 9.63zM9.503 47.07a2.918 2.918 0 0 0 2.914 2.914 2.917 2.917 0 0 0 2.914-2.914 2.917 2.917 0 0 0-2.914-2.915 2.918 2.918 0 0 0-2.914 2.915zM5.47 59.868h10.16c.002-.33.035-.662.104-.992.185-.894.444-1.77.768-2.618a7.283 7.283 0 0 0-4.02-1.205h-.132c-3.094 0-5.837 1.971-6.88 4.815z"
                  />
                </svg>
              </figure>
              <span class="d-block h4 font-weight-normal">{displayStaffText}</span>
            </Link>
          </li>
        )}
      </ul>,
    ];

    return (
      <div class="manage-dashboard container-fluid">
        <PageTitle TitleText="Admin" />
        <div class="row">
          <div class="col-md-12 mar-top-30">
            <h1 class="main-head mt-5">ADMIN</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">{links[0]}</div>
        </div>
      </div>
    );
  }
}

export default ClinicalAdmin;
